/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import Options from './Options/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/Carrier/Content",
  onChangeFilter,
  isInvalid,
  onChange
  
}) {
let globalCurrentLocationPermissionsHasPatientInsuranceEditValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location.permissions.has_patient_insurance_edit',
format: fromFormat.not,
})
let selectedCarrierSearchValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'carrier_search',
})
let carriersValueData = fromData.useDataValue({ viewPath,
context: 'carriers',
})
let planDetailsCarrierValueData = fromData.useDataValue({ viewPath,
context: 'plan_details',
path: 'carrier',
})
let planDetailsCarrierIsValidData = fromData.useDataIsValid({ viewPath,
context: 'plan_details',
path: 'carrier',
validate: fromValidate.numberPositive,
required: true,
})
let planDetailsCarrierChangeData = fromData.useDataChange({ viewPath,
context: 'plan_details',
path: 'carrier',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="global.current_location.permissions.has_patient_insurance_edit"
 format="/Data/format.js not"
 disabled={globalCurrentLocationPermissionsHasPatientInsuranceEditValueData}
 isMultiChoice={false}
 marginTop={0}
 placeholder="Search..."
 marginRight={dtSpaceM}
 data="selected.carrier_search"
 valueFilter={selectedCarrierSearchValueData}
 onChangeFilter={onChangeFilter}
 data="carriers"
 from={carriersValueData}
 data="plan_details.carrier"
 validate="/Data/validate.js numberPositive"
 invalid={!planDetailsCarrierIsValidData}
 required={true}
 value={planDetailsCarrierValueData}
 onChange={planDetailsCarrierChangeData}
 optionsWidth={390}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaSelectOneLabel
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Insurance Carrier"
/>
<Options
  viewPath={`${viewPath}/Options`}
/>
</div>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}